<template>
  <div class="language">
    <div
      v-on:mouseover="showToggle(true)"
      v-on:mouseout="showToggle(false)"
      :class="[NavBar == 1 ? 'NarBarUlColor1' : 'NarBarUlColor2']"
    >
      <div
        class="login_txt"
        :class="[NavBar == 1 ? 'NarBarColor1' : 'NarBarColor2']"
      >
        <div v-if="currentLanguage == 'zh'" >
          <i class="iconfont icon-diqiu1"></i>中文
        </div>
        <div v-else-if="currentLanguage == 'en'"><i class="iconfont icon-diqiu1"></i>English</div>
         <div v-else-if="currentLanguage == 'fran'"><i class="iconfont icon-diqiu1"></i>Français</div>
      </div>
      <!-- index === isShow -->
      <!-- showMenuList -->
      <div v-show=" showMenuList">
        <div class="hoverShow">
          <div
            @click="languageFun('zh')"
            :class="['zh' == currentLanguage ? 'activeLanguage' : '']"
          >
            <!-- {{$t('Nav.Menu.ZH')}} -->
            中文
          </div>
          <div
            @click="languageFun('en')"
            :class="['en' == currentLanguage ? 'activeLanguage' : '']"
          >
           <!-- {{$t('Nav.Menu.EN')}} -->
           English
          </div>

           <div
            @click="languageFun('fran')"
            :class="['fran' == currentLanguage ? 'activeLanguage' : '']"
          >
           Français
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["NavBar"],
  mounted() {
    this.currentLanguage = localStorage.getItem("locale")?localStorage.getItem("locale"):'zh';
  },
  data() {
    return {
      Menu: [],
      currentLanguage: "zh",
      showMenuList: false,
    };
  },

  methods: {
    languageFun(val) {
      //   if(val == 'en'){
      //  this.$message({
      //    duration:1500,
      //       message: '正在开发中',
      //       center: true
      //     });
      //     return
      //   }
      localStorage.setItem("locale", val);
      this.setLanguage(val);
      this.$i18n.locale = localStorage.getItem("locale");
      this.currentLanguage = val;
    },
    toLogin() {
      this.$router.push("/login");

    },
    showToggle(boole) {
      this.showMenuList = boole;
    },
  },
  created() {},
};
</script>
  <style scoped lang="scss">
.language {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  // margin-left: 30px;
  // margin-right: 20px;
}

.active {
  //   color: #000;
  /* background-color: rgba(0, 0, 0, 0.3); */
  background-size: 50% 4px !important;
}

.login_txt {

  // color: #fff;
  background-image: linear-gradient(#fff, #fff);
  background-position: center bottom;
  background-repeat: no-repeat;
  transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  text-decoration: none;
  // height: 66px;
  z-index: 999;
  background-size: 0 4px;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px;
  cursor: pointer;

  i {
     font-size: 12px;
    margin-right: 10px;
  }
}
.NarBarColor1 {
  color: #ccc;
  height: 26px;
}
.NarBarColor2 {
  color: #000;
}
.sort:last-child {
  width: 130px;
}
.sort:nth-child(3) {
  width: 120px;
}

.hoverShow {
  z-index: 999;
  cursor: pointer;
  //   width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 3px;
}
.hoverShow div {
  text-align: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
}
// .hoverShow div:hover {
//   background: rgba(0, 0, 0, 0.6);
// }
.NarBarUlColor1 {
  .title {
    color: #fff;
    background-image: linear-gradient(#fff, #fff);
  }
  .activeLanguage {
            background: rgba(0, 0, 0, .7) !important;
    color: #066cac !important;
 

  }
  .hoverShow div {
    color: #fff;
    background: rgba(0, 0, 0, 0.5);

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      //   opacity: .8;
    }
  }
}
.NarBarUlColor2 {
  .title {
    color: #000;
    background-image: linear-gradient(#0052d9, #0052d9);
  }
  .activeLanguage {
        background: rgba(255, 255, 255, .8) !important;
    color: #066cac !important;
  }
  .hoverShow div {
    color: #000;
    background: rgba(255, 255, 255, 1);

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>

